'use strict';

import React, { Component } from 'react';
import { isMobile, isTablet } from "react-device-detect";

//import InfoContent from './InfoContent';

class ListItemComponent extends Component {
  constructor(props) {
    super(props);

    this.event = this.props.event;

    this.setInfoWindow = this.setInfoWindow.bind(this);
    this.setCurrentinfoWindow = this.setCurrentinfoWindow.bind(this);
    this.processSize = this.processSize.bind(this);

    this.props.mapApi.event.addListener(
      this.props.mapRef,
      'zoom_changed',
      () => {
        this.currentInfowindow && this.currentInfowindow.close();
      },
    );
  }

  processSize(size) {
    var temp = size.split(' ');
    return parseFloat(temp[0]) + ' ' + temp[1];
  }

  setInfoWindow() {
    const SnazzyInfoWindow = require('snazzy-info-window');

    let hr_by = '';
    if (this.event.content.supportingAgencies && this.event.content.supportingAgencies != null) {
      hr_by += this.event.content.supportingAgencies + ', ';
    }
    if (this.event.content.leadAgency) {
      hr_by += this.event.content.leadAgency;
    }

    const infoContent = `<div class="o__infowindow">
        <div class="info__heading">
          <h5>${this.event.content.location}</h5>
        </div>

        <div class="info__content">
          <ul>
            <li>
              <span>Location:</span>
              <span>${this.event.content.lga}</span>
            </li>
            <li>
              <span>Date:</span>
              <span>
                ${this.event.content.startDate}
                ${' - '}
                ${this.event.content.endDate}
              </span>
            </li>
            <li>
              <span>Tenure:</span>
              <span>${this.event.content.tenure}</span>
            </li>
            <li>
              <span>HR By:</span>
              <span>
                ${hr_by}
              </span>
            </li>
            <li>
              <span>Size:</span>
              <span>${this.processSize(this.event.content.size)}</span>
            </li>
          </ul>
        </div>
      </div>`;
    const setCurrent = this.setCurrentinfoWindow;
    const showMap = this.props.handleMenuTabClick;
    return new SnazzyInfoWindow({
      map: this.props.mapRef,
      position: this.event.center,
      padding: '0px',
      closeWhenOthersOpen: true,
      showCloseButton: true,
      content: infoContent,
      callbacks: {
        open: function () {
          setCurrent(this);
          if (isTablet) {
            if (window.orientation == 90) {
              return;
            }
          }
          if (isMobile) {
            showMap('tabMap');
          }
        },
      },
    });
  }

  setCurrentinfoWindow(infoWindow) {
    this.currentInfowindow = infoWindow;
  }

  render() {
    return (
      <li
        className="event-item"
        onClick={() => {
          const infoWindow = this.setInfoWindow();
          infoWindow.open();
        }}
      >
        <div className="event__title">
          {this.event.content.location}{', '}{this.event.content.lga}
        </div>
        <div className="event__location">{this.event.content.lga}</div>
        <div className="event__date">
          <span className="event__date-start">{this.event.content.startDate}</span>
          {' - '}
          <span className="event__date-end">{this.event.content.endDate}</span>
        </div>
      </li>
    );
  }
}

export default ListItemComponent;
